import React, { useEffect, useState } from 'react';
import '../styles/Search.scss';
import View from '../components/View';
import PageHeader from '../components/PageHeader';
import SearchBarFilter from '../components/SearchBarFilter';
import CatalogueItem from '../components/CatalogueItem';

import {
  didFetchingProductsFailed,
  getProducts,
  isFetchingProducts,
} from '../selectors/Product';
import { useSelector, useDispatch } from 'react-redux';
import { fetchProductTypes } from '../actions/ProductType';
import { fetchProducts } from '../actions/Product';
import { getProductTypes } from '../selectors/ProductType';
import { getCategoryBannerImage, objectToQueryString, useQuery } from '../helpers/functions';
import _ from 'lodash';
import DropDown from '../components/DropDown';
import { Product } from '../types/Product';
import history from '../helpers/history';
import c from '../helpers/constants';

const Search = () => {
  const fetchingProducts = useSelector(isFetchingProducts);
  const products = useSelector(getProducts);
  const productTypes = useSelector(getProductTypes);
  const [title, setTitle] = useState('');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [pageIndex, setPageIndex] = useState(0);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showFirst, setShowFirst] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showPrevious, setShowPrevious] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showNext, setShowNext] = useState(true);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showLast, setShowLast] = useState(true);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [pageCount, setPageCount] = useState(0);
  const [pageRange, setPageRange] = useState([]);
  const [productsPerPage, setProductsPerPage] = useState(9);
  const fetchingFailed = useSelector(didFetchingProductsFailed);
  const query = useQuery();
  const dispatch = useDispatch();
  const productTypeCode = query.get('productTypeCode') || undefined;
  const searchSelection = query.get('searchSelection') || undefined;

  useEffect(() => {
    setTitle('');
    dispatch(fetchProductTypes());
    dispatch(fetchProducts(productTypeCode, searchSelection));
  }, [dispatch, productTypeCode, searchSelection]);



  useEffect(()=>{
    if (productTypes?.length > 0 && productTypeCode) {
      const found = productTypes?.find(p => p.product_type_code === productTypeCode);
      setTitle(_.startCase(_.toLower(found?.product_type_desc)));
    }
  }, [productTypes]);

  useEffect(()=>{
    if (products?.length > 0) {
      if (searchSelection) {
        setTitle(`We found ${products?.length} products for: ${searchSelection}`);
      }
      let localPageCount = products?.length / productsPerPage;
      if (localPageCount > 5) {
        localPageCount = 5;
      }
      setPageIndex(0);
      setPageCount(localPageCount);
      // @ts-ignore
      setPageRange(_.range(0, localPageCount));
    }
  }, [products]);

  const onClickIndex = (goToIndex: number) => {
    const first = _.first(pageRange) || 0;
    const last = _.last(pageRange) || 5;
    setPageIndex(goToIndex);
    let localPageCount = Math.floor(products?.length / productsPerPage);
    setShowPrevious(first > 0);
    setShowFirst(pageIndex > 0);
    setShowNext(last < localPageCount);
    setShowLast(pageIndex < localPageCount);
  };

  const onNext = () => {
    if (!showNext) return;
    const first = _.first(pageRange) || 0;
    const last = _.last(pageRange) || 5;
    const firstT = first + 1;
    const lastT = last + 2;
    // @ts-ignore
    setPageRange(_.range(firstT, lastT));
    // @ts-ignore
    // setPageIndex(last);
    let localPageCount = Math.floor(products?.length / productsPerPage);
    setShowPrevious(first > 0);
    setShowFirst(pageIndex > 0);
    setShowNext(last < localPageCount);
    setShowLast(pageIndex < localPageCount);
  };

  const onPrevious = () => {
    if (!showPrevious) return;
    const first = _.first(pageRange) || 0;
    const last = _.last(pageRange) || 5;
    const firstT = first - 2;
    const lastT = last - 1;
    let localPageCount = Math.floor(products?.length / productsPerPage);
    // @ts-ignore
    setPageRange(_.range(firstT, lastT));
    // @ts-ignore
    // setPageIndex(last);
    setShowPrevious(first > 0);
    setShowFirst(pageIndex > 0);
    setShowNext(last < localPageCount);
    setShowLast(pageIndex < localPageCount);
  };

  const onFirst = () => {
    if (!showFirst) return;
    // @ts-ignore
    setPageRange(_.range(0, 5));
    setPageIndex(0);
    setShowPrevious(false);
    setShowFirst(false);
    setShowNext(true);
    setShowLast(true);
  };

  const onLast = () => {
    if (!showLast) return;
    let localPageCount = Math.floor(products?.length / productsPerPage);
    // @ts-ignore
    setPageRange(_.range(localPageCount - 4, localPageCount + 1));
    setPageIndex(localPageCount);
    setShowPrevious(true);
    setShowFirst(true);
    setShowNext(false);
    setShowLast(false);
  };
  const sizes = [
    { label: '9 per page', value: 9 },
    { label: '18 per page', value: 18 },
    { label: '27 per page', value: 27 },
  ];

  const onChangePageSize = (size: any) => {
    setProductsPerPage(size.value);
    onClickIndex(0);
  };

  const onClickProduct = (product: Product) => {
    history.push({ pathname: c.APP_ROUTES.PRODUCT_CUT, search: `sku=${product.product_sku || product.IMAGE_code}` });
  };

  const onSearch = (term: string) => {
    const obj = {
      searchSelection: term,
      productTypeCode,
    };
    history.push({ pathname: c.APP_ROUTES.SEARCH, search: objectToQueryString(obj) });
  };

  const renderPaging = () => products?.length > 0 && <div className="row gy-5 search-row pb-5">
    <div className="col-md-4">
      <div className="d-flex justify-content-start align-content-center flex-row align-items-center">
        <div>Results:&nbsp;&nbsp;&nbsp;</div>
        <DropDown items={sizes} value={productsPerPage} onSelect={onChangePageSize} />
      </div>
    </div>
    <div className="col-md-8">
      <div className="lw-pagination">
        <div className={`lw-pagination__control ${!showFirst ? 'disabled' : ''}`} onClick={onFirst}> First </div>
        <div className={`lw-pagination__control ${!showPrevious ? 'disabled' : ''}`} onClick={onPrevious}> Previous </div>
        {pageRange.map((index) => (
            <div
                onClick={() => onClickIndex(index)}
                className={`lw-pagination__pill ${pageIndex === index ? 'active-pill' : ''}`}
                key={index}>
              {index + 1}
            </div>
        ))}
        <div className={`lw-pagination__control ${!showNext ? 'disabled' : ''}`}  onClick={onNext}> Next </div>
        <div className={`lw-pagination__control ${!showLast ? 'disabled' : ''}`}  onClick={onLast}> Last </div>
      </div>
    </div>
  </div>;

  return (
        <View>
            <PageHeader text={title} imageUrl={getCategoryBannerImage(productTypeCode)}/>
            <div className="container pb-5">
                <div className="search">
                    <SearchBarFilter onSearch={onSearch} term={searchSelection}/>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-12 mb-5 text-center">
                            {fetchingProducts && !fetchingFailed &&
                            <div className="spinner-border text-center text-dark" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                            }
                        </div>
                    </div>
                  {renderPaging()}
                    <div className="row gy-5 search-row pb-5">
                        {_.slice(products, pageIndex * productsPerPage, (pageIndex * productsPerPage)  + productsPerPage)?.map((p, i) => (
                            <div key={`${p.quality_full_name}-${i}`} className="col-lg-4 col-md-6">
                                <CatalogueItem
                                    onClick={() => onClickProduct(p)}
                                    imageCode={p.IMAGE_code}
                                    productName={p.quality_full_name}
                                    productDetails={p.colour_full_name}
                                    price={p.price_from}
                                />
                            </div>
                        ))}
                        {!fetchingProducts && !fetchingFailed && products?.length === 0 && <div className="text-center">No records found matching your search.</div>}
                    </div>
                  {renderPaging()}
                </div>
            </div>
        </View>
  );
};

export default Search;
